import { useEffect, useRef, useState } from 'react';

import { useTitlesApi } from '@api/hooks/useTitlesApi';

type Options = {
  disabled?: boolean;
  fieldName?: string;
  minLength?: number;
};

const useSuggestAsYouType = (queryText: string, options?: Options) => {
  const { disabled, fieldName, minLength = 1 } = options || {};
  const { suggestValues } = useTitlesApi();

  const [loading, setLoading] = useState(false);
  const [suggestions, setSuggestions] = useState<string[]>([]);
  const timer = useRef<NodeJS.Timeout>(undefined);

  useEffect(() => {
    if (timer.current) clearTimeout(timer.current);
    if (disabled) return;
    setLoading(false);

    if (!queryText || queryText.length < minLength) {
      setSuggestions([]);
      return;
    }

    timer.current = setTimeout(async () => {
      setLoading(true);

      suggestValues(queryText, fieldName)
        .then(({ data: searchSuggestions, ok, originalError }) => {
          if (originalError) throw originalError;
          if (!ok || !searchSuggestions) throw new Error();
          setSuggestions(searchSuggestions);
        })
        .catch(console.error)
        .finally(() => setLoading(false));
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryText, disabled]);

  useEffect(() => {
    return () => {
      if (timer.current) clearTimeout(timer.current);
    };
  }, []);

  return { loading: loading && suggestions.length > 0, suggestions };
};

export default useSuggestAsYouType;
